//
export default [
  {
    name: 'code',
    type: 'text-field',
    props: {
      label: 'Codigo',
    },
  },
  {
    name: 'bank',
    type: 'text-field',
    props: {
      label: 'Nombre',
    },
  },
]
